import { t } from "components/CentralDataMangement/translation/Translation";



export const createFilterConfig = () => {
  return [
    {
      name: "userName",
      fieldType: "text",
      placeholder: t("Username"),
      filterType: 'search',
      label: t("User Name")
    },
    {
      name: "instance",
      fieldType: "text", 
      placeholder: t("Instance Id"),
      filterType: 'search',
      label: t("Instance Id")
    }
  ];
};